module.exports = __webpack_public_path__ + "img/logo_light.a8bff2bd.svg";